import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "firebaseui-auth-container" }

import 'firebase/compat/auth';
import 'firebase/compat/firestore';
import { signin } from './code/firebase-manager'

export default /*#__PURE__*/_defineComponent({
  __name: 'Home',
  setup(__props) {

signin()


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1))
}
}

})